import { CellContext } from "@tanstack/react-table";

export default function SelectionCell<RowType>(
  props: CellContext<RowType, any>
) {
  const {
    row: { getCanSelect, getIsSelected, toggleSelected },
  } = props;

  if (!getCanSelect()) return null;

  return (
    <input
      type="checkbox"
      checked={getIsSelected()}
      onChange={() => toggleSelected()}
    />
  );
}
